import React, { FC } from 'react';
import MUIAlert from '../../../ui-component/mui-alert/MUIAlert';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PAGES_URLS } from '../../../../lib/constants/routes';

const NachRegistrierung: FC<{ isRegistrationSuccess: boolean | null }> = ({ isRegistrationSuccess }) => {
	const navigate = useNavigate();

	if (isRegistrationSuccess) {
		return (
			<>
				<MUIAlert
					infoType="success"
					title="Vielen Dank für Ihre Registrierung!"
					message="Um Ihre Registrierung abzuschließen, haben wir Ihnen eine E-Mail mit einem Bestätigungslink zugesendet.Bitte überprüfen Sie Ihren Posteingang und klicken Sie auf den Link, um Ihre E-Mail-Adresse zu verifizieren.
					Hinweis: Der Bestätigungslink ist nur 24 Stunden gültig. Sollten Sie innerhalb dieses Zeitraums keine Bestätigung vornehmen, verfällt der Link und Sie müssen den Registrierungsprozess erneut durchlaufen.
					Wenn Sie keine E-Mail erhalten haben, überprüfen Sie bitte auch Ihren Spam-Ordner oder kontaktieren Sie unseren Support."
				/>
				<Button onClick={() => navigate(PAGES_URLS.Login)} sx={{ mt: '2rem' }}>
					{' '}
					Zurück zur Login-Seite
				</Button>
			</>
		);
	} else if (!isRegistrationSuccess) {
		return <MUIAlert infoType="error" message="Etwas ist schief gelaufen. Versuchen Sie es bitte ernuet." />;
	}

	return <></>;
};

export default NachRegistrierung;
